<template v-slot:placeholder>
    <v-layout
    fill-height
    align-center
    justify-center
    ma-0>
    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
    </v-layout>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
